import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetCoffinPlacingController::__invoke
* @see app/Http/Controllers/Screen/GetCoffinPlacingController.php
* @route '/api/screen/data/get-coffin-placing'
*/
const GetCoffinPlacingController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCoffinPlacingController.url(options),
    method: 'get',
})

GetCoffinPlacingController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-coffin-placing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetCoffinPlacingController::__invoke
* @see app/Http/Controllers/Screen/GetCoffinPlacingController.php
* @route '/api/screen/data/get-coffin-placing'
*/
GetCoffinPlacingController.url = (options?: RouteQueryOptions) => {
    return GetCoffinPlacingController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetCoffinPlacingController::__invoke
* @see app/Http/Controllers/Screen/GetCoffinPlacingController.php
* @route '/api/screen/data/get-coffin-placing'
*/
GetCoffinPlacingController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCoffinPlacingController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetCoffinPlacingController::__invoke
* @see app/Http/Controllers/Screen/GetCoffinPlacingController.php
* @route '/api/screen/data/get-coffin-placing'
*/
GetCoffinPlacingController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCoffinPlacingController.url(options),
    method: 'head',
})

export default GetCoffinPlacingController